import { cn } from "@/lib/utils";

/**
 * A printed checklist: an empty box and a line of text per item, ruled between. The
 * boxes are drawn, not inputs — this is something to read (or print), and a page of
 * real checkboxes implies the site will remember them.
 */
export function Checklist({ items, className }: { items: readonly string[]; className?: string }) {
  return (
    <ul
      className={cn(
        "divide-y divide-border border-y border-border sm:columns-2 sm:gap-10",
        className,
      )}
    >
      {items.map((t) => (
        <li key={t} className="flex break-inside-avoid gap-3 py-3 text-[0.9375rem] leading-snug">
          <span
            aria-hidden
            className="mt-[0.2em] h-3.5 w-3.5 shrink-0 rounded-[2px] border-[1.5px] border-foreground/60"
          />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

/** A row of place links separated by middots, for "nearby states" and similar. */
export function InlineLinks({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <ul
      className={cn(
        "flex flex-wrap gap-y-1.5 text-[0.9375rem] [&>li:not(:last-child)]:after:mx-2.5 [&>li:not(:last-child)]:after:text-muted-foreground [&>li:not(:last-child)]:after:content-['·']",
        className,
      )}
    >
      {children}
    </ul>
  );
}
